<template>
  <div
    class="app"
    :class="state.CURRENT_DISPLAY === 'PAYMENT_BREAKDOWN' ? 'payment-breakdown' : 'amortization-schedule'"
  >
    <div class="bar"></div>
    <link rel="stylesheet" href="https://use.typekit.net/won6txh.css" />
    <DownpaymentSlider class="downpayment-slider" />
    <DownPayment class="downpayment" />
    <EstimatedPayment class="estimated-payment" />
    <Tabs class="tabs" />
    <PayoffAdjustmentText class="payoff-adjustment-text" />
    <PayoffAdjustments class="payoff-adjustment" />
    <AmortizationGraph class="amortization-graph" />
    <AmortizationInfo class="amortization-info" />
    <PayoffDate class="payoff-date" />
    <AmortizationTable class="amortization-table" />
    <PaymentBreakdownAdjustments class="payment-breakdown-adjustments" />
    <PaymentBreakdownGraph class="payment-breakdown-graph" />
  </div>
</template>
<script>
import store from "./store/index.js";
import DownpaymentSlider from "./components/DownpaymentSlider";
import DownPayment from "./components/DownPayment";
import EstimatedPayment from "./components/EstimatedPayment";
import PayoffAdjustments from "./components/PayoffAdjustments";
import AmortizationGraph from "./components/AmortizationGraph";
import AmortizationInfo from "./components/AmortizationInfo";
import PayoffDate from "./components/PayoffDate";
import PaymentBreakdownAdjustments from "./components/PaymentBreakdownAdjustments";
import AmortizationTable from "./components/AmortizationTable";
import Tabs from "./components/Tabs";
import PayoffAdjustmentText from "./components/PayoffAdjustmentText";
import PaymentBreakdownGraph from "./components/PaymentBreakdownGraph";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  store,
  name: "App",
  components: {
    DownpaymentSlider,
    DownPayment,
    EstimatedPayment,
    Tabs,
    AmortizationGraph,
    AmortizationInfo,
    PayoffDate,
    PayoffAdjustmentText,
    PayoffAdjustments,
    AmortizationTable,
    PaymentBreakdownAdjustments,
    PaymentBreakdownGraph
  },
  computed: {
    ...mapState({
      state: state => state.base
    })
  }
};
</script>
<style lang="scss" >
.app {
  width: 100%;
  .bar-bottom {
    display: none;
  }
  @media (min-width: 768px) {
    .tabs {
      margin-top: 50px;
    }
  }

  margin: auto;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto 272px auto auto auto auto auto auto auto;
  grid-row-gap: 30px;
  .estimated-payment {
    @media (min-width: 768px) {
      height: calc(100% - 30px) !important;
    }
  }
  &.amortization-schedule {
    .estimated-payment {
      align-self: end;
    }
    grid-template-rows: auto 272px auto auto auto auto auto auto auto;
    grid-template-columns: 100%;
    grid-template-areas:
      "bar"
      "downpayment-slider"
      "downpayment"
      "estimated-payment"
      "tabs"
      "payoff-adjustment-text"
      "payoff-adjustment"
      "amortization-graph"
      "amortization-info"
      "payoff-date"
      "amortization-table";
    @media (min-width: 768px) {
      grid-template-columns: 50% 50%;
      grid-template-rows: auto auto auto auto auto auto auto auto;
      grid-row-gap: 15px;
      grid-template-areas:
        "bar bar"
        "downpayment-slider downpayment"
        "estimated-payment estimated-payment"
        "tabs tabs"
        "payoff-adjustment-text amortization-graph"
        "payoff-adjustment amortization-graph"
        "payoff-date amortization-info"
        "amortization-table amortization-table";
      .estimated-payment {
        border-top: solid 1px #f3f3f3;
      }
      .payoff-date {
        height: 100%;
      }
    }
    @media (min-width: 1024px) {
      grid-template-columns: 40% 60%;
      grid-template-rows: auto auto auto auto auto auto auto;
      grid-row-gap: 0px;
      .estimated-payment {
        border-top: none;
      }
      grid-template-areas:
        "bar bar"
        "downpayment-slider estimated-payment"
        "downpayment-slider tabs"
        "downpayment payoff-adjustment-text"
        "downpayment payoff-adjustment"
        "downpayment amortization-graph"
        "payoff-date amortization-graph"
        "amortization-info amortization-graph"
        "amortization-table amortization-table";
      // "bar-bottom bar-bottom";
      .payoff-date {
        height: 152px;
      }
      .bar-bottom {
        display: block;
      }

      .payoff-adjustment-text {
        margin-top: 30px;
      }
      .amortization-graph {
        canvas {
          margin-top: 30px;
        }
      }
      .amortization-table {
        margin-top: 30px;
      }
      .amortization-table,
      .downpayment {
        margin-bottom: 30px;
        .input-field {
          &.downpayment-interest {
            margin-bottom: 0;
          }
          width: 100%;
          &.downpayment-percentage {
            width: 27.4%;
          }
          &.downpayment-dollars {
            width: 72.6%;
          }
        }
      }
      .bar {
        margin-bottom: 30px;
      }
      .estimated-payment {
        height: calc(100% - 60px);
      }
      .downpayment,
      .downpayment-slider {
        text-align: left;
        padding-right: 30px;
        border-right: solid 1px #e3e3e3;
      }

      .payoff-date,
      .amortization-info {
        text-align: left;
      }
      .tabs {
        justify-content: flex-end;
        .selection-bar {
          .bar {
            margin-top: 0px;
          }
        }
      }
      .amortization-info {
        margin-top: 30px;

        height: 190px;
      }
      div.payoff-adjustment {
        height: 150px;
        display: flex;
        margin-top: 10px;
        .input-group {
          display: flex;
          flex-wrap: wrap;
          width: 33%;
          justify-content: center;
          &:nth-of-type(2) {
            border-left: 1px solid #eeeeee;
            border-right: 1px solid #eeeeee;
          }
        }
        .input-field {
          position: relative;
          width: 90%;
          height: 80px;
          .label {
            margin-bottom: 0px;
            margin-top: 3px;
          }
          .error {
            top: 72px;
          }
        }
      }
    }
    @media (min-width: 1350px) {
      grid-template-columns: 40% 30% 30%;
      grid-template-rows:
        auto auto auto auto auto 185px auto 190px auto
        auto;
      grid-row-gap: 0px;
      .estimated-payment {
        border-top: none;
      }
      grid-template-areas:
        "bar bar bar"
        "downpayment-slider estimated-payment estimated-payment"
        "downpayment-slider tabs tabs"
        "downpayment-slider tabs tabs"
        "downpayment payoff-adjustment-text payoff-adjustment-text"
        "downpayment payoff-adjustment payoff-adjustment"
        "downpayment payoff-date payoff-date"
        "amortization-info amortization-table amortization-table"
        "amortization-graph amortization-table amortization-table";
      // "bar-bottom bar-bottom bar-bottom";
      div.amortization-table {
        height: 730px;
      }
      .amortization-info {
        //  margin-bottom: 30px;

        margin-top: 0;
      }
      .amortization-table {
        margin-top: 0;
      }
      .amortization-graph {
        canvas {
          margin-top: 0;
        }
      }
      .payoff-date {
        height: 100px;
        margin-bottom: 15px;
      }

      .amortization-graph {
        align-self: flex-end;
      }
      div.payoff-adjustment {
        margin-top: 20px;
      }
    }
    .payment-breakdown-graph {
      display: none;
    }
    .payment-breakdown-adjustments {
      display: none;
    }
  }
  &.payment-breakdown {
    .estimated-payment {
      align-self: end;
    }
    .payment-breakdown-graph {
      width: 272px;
      align-self: center;
    }
    .payoff-adjustment-text {
      display: none;
    }
    .payoff-adjustment {
      display: none;
    }
    .payoff-date {
      display: none;
    }
    .amortization-graph {
      display: none;
    }
    .amortization-info {
      display: none;
    }
    .amortization-table {
      display: none;
    }
    grid-template-rows: auto 272px auto auto auto 272px auto;
    grid-template-columns: 100%;
    grid-template-areas:
      "bar"
      "downpayment-slider"
      "downpayment"
      "estimated-payment"
      "tabs"
      "payment-breakdown-graph"
      "payment-breakdown-adjustments";
    @media (min-width: 768px) {
      grid-template-columns: 50% 50%;
      grid-template-rows: auto auto auto auto auto auto auto auto;
      grid-row-gap: 15px;
      grid-template-areas:
        "bar bar"
        "downpayment-slider downpayment"
        "estimated-payment estimated-payment"
        "tabs tabs"
        "payment-breakdown-graph payment-breakdown-graph"
        "payment-breakdown-adjustments payment-breakdown-adjustments";
      .estimated-payment {
        border-top: solid 1px #f3f3f3;
      }
      .payoff-date {
        height: 100% !important;
      }
    }
    @media (min-width: 1024px) {
      grid-template-columns: 40% 60%;
      grid-template-rows: auto auto auto auto auto auto auto;
      grid-row-gap: 0px;
      .estimated-payment {
        border-top: none;
      }
      grid-template-areas:
        "bar bar"
        "downpayment-slider estimated-payment"
        "downpayment-slider tabs"
        "downpayment payment-breakdown-graph"
        "downpayment payment-breakdown-graph"
        "payment-breakdown-adjustments payment-breakdown-adjustments";
      // "bar-bottom bar-bottom";
      .bar-bottom {
        display: block;
      }

      .tabs {
        margin-top: 50px;
      }
      .downpayment {
        margin-bottom: 30px;
        .input-field {
          &.downpayment-interest {
            margin-bottom: 0;
          }
          width: 100%;
          &.downpayment-percentage {
            width: 27.4%;
          }
          &.downpayment-dollars {
            width: 72.6%;
          }
        }
      }
      .bar {
        margin-bottom: 30px;
      }
      .estimated-payment {
        height: calc(100% - 60px);
      }
      .downpayment,
      .downpayment-slider {
        text-align: left;
        padding-right: 30px;
        border-right: solid 1px #e3e3e3;
      }

      .tabs {
        justify-content: flex-end;
        .selection-bar {
          .bar {
            margin-top: 0px;
          }
        }
      }
    }
    @media (min-width: 1350px) {
      grid-template-columns: 40% 30% 30%;
      grid-template-rows: auto auto auto auto auto auto auto;
      grid-row-gap: 0px;
      .estimated-payment {
        border-top: none;
      }
      grid-template-areas:
        "bar bar bar"
        "downpayment-slider estimated-payment estimated-payment"
        "downpayment-slider tabs tabs"
        "downpayment-slider tabs tabs"
        "downpayment payment-breakdown-graph payment-breakdown-adjustments";
      // "bar-bottom bar-bottom bar-bottom";
      .estimated-payment {
        align-self: end;
      }
    }
  }

  > * {
    width: calc(100% - 24px);
    justify-self: center;
  }

  > * {
    box-sizing: border-box !important;
  }

  .downpayment-slider {
    grid-area: downpayment-slider;
  }
  .tabs {
    grid-area: tabs;
  }
  .payoff-adjustment-text {
    grid-area: payoff-adjustment-text;
  }
  .downpayment {
    grid-area: downpayment;
  }
  .estimated-payment {
    grid-area: estimated-payment;
  }
  .payoff-adjustment {
    grid-area: payoff-adjustment;
  }
  .amortization-graph {
    grid-area: amortization-graph;
  }
  .amortization-info {
    grid-area: amortization-info;
  }
  .payoff-date {
    grid-area: payoff-date;
  }
  .amortization-table {
    grid-area: amortization-table;
  }
  .payment-breakdown-graph {
    grid-area: payment-breakdown-graph;
  }
  .payment-breakdown-adjustments {
    grid-area: payment-breakdown-adjustments;
  }
  .bar {
    //margin-bottom: 30px;
    grid-area: bar;
    height: 9px;
    background-color: #e3e3e3;
    @media (min-width: 768px) {
      margin-bottom: 15px;
    }
    @media (min-width: 1350px) {
      margin-bottom: 30px;
    }
  }
  .bar-bottom {
    margin-top: 30px;
    grid-area: bar-bottom;
    height: 9px;
    background-color: #e3e3e3;
  }
}
</style>

<style lang="scss">
.app {
  > * {
    box-sizing: border-box !important;
  }
}
</style>

